let lightbox = null

function createLightbox() {
  if (lightbox) return lightbox

  lightbox = document.createElement('div')
  lightbox.className = 'lightbox'
  lightbox.innerHTML = '<button class="button button-tag lightbox-close" aria-label="Close">zurück</button><img alt="">'

  lightbox.addEventListener('click', closeLightbox)
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeLightbox()
  })

  return lightbox
}

function whenImageReady(img) {
  return new Promise((resolve) => {
    let done = false
    const finish = () => {
      if (done) return
      done = true
      img.removeEventListener('load', finish)
      img.removeEventListener('error', finish)
      resolve()
    }
    if (img.complete && img.naturalWidth > 0) return finish()
    img.addEventListener('load', finish)
    img.addEventListener('error', finish)
    // Safety fallback so we never hang forever on a slow image.
    setTimeout(finish, 1500)
  })
}

function openLightbox(source) {
  const lb = createLightbox()
  const img = lb.querySelector('img')

  // When the trigger is the icon button, fly from the slide image instead of the tiny button.
  const animationOrigin = source.closest('.swiper-slide')?.querySelector('img') || source
  const rect = animationOrigin.getBoundingClientRect()

  const sm = source.dataset.lightboxSm
  const md = source.dataset.lightboxMd
  const xl = source.dataset.lightboxXl

  // Calculate target size that fits 90vw × 90vh while preserving aspect ratio
  const imgW = parseInt(source.dataset.lightboxW)
  const imgH = parseInt(source.dataset.lightboxH)
  const maxW = window.innerWidth * 0.9
  const maxH = window.innerHeight * 0.9
  const scale = Math.min(maxW / imgW, maxH / imgH)
  const targetW = imgW * scale
  const targetH = imgH * scale

  lb.style.setProperty('--lb-top', `${rect.top}px`)
  lb.style.setProperty('--lb-left', `${rect.left}px`)
  lb.style.setProperty('--lb-width', `${rect.width}px`)
  lb.style.setProperty('--lb-height', `${rect.height}px`)
  lb.style.setProperty('--lb-target-top', `${(window.innerHeight - targetH) / 2}px`)
  lb.style.setProperty('--lb-target-left', `${(window.innerWidth - targetW) / 2}px`)
  lb.style.setProperty('--lb-target-width', `${targetW}px`)
  lb.style.setProperty('--lb-target-height', `${targetH}px`)

  // Clear stale srcset *before* setting src so the browser doesn't keep
  // displaying the previously decoded image during the open animation.
  img.removeAttribute('srcset')
  img.removeAttribute('src')
  img.srcset = `${sm} 640w, ${md} 1280w, ${xl} 1920w`
  img.sizes = '100vw'
  img.src = md

  whenImageReady(img).then(() => {
    document.body.appendChild(lb)
    lb.offsetHeight // force reflow
    lb.classList.add('lightbox-open')
    document.body.classList.add('lightbox-open')
  })
}

function closeLightbox() {
  if (!lightbox || !lightbox.classList.contains('lightbox-open')) return

  lightbox.classList.remove('lightbox-open')
  document.body.classList.remove('lightbox-open')

  lightbox.addEventListener('transitionend', () => {
    lightbox.remove()
  }, { once: true })
}

document.addEventListener('click', e => {
  const source = e.target.closest('[data-lightbox]')
  if (!source) return
  openLightbox(source)
})

// Warm the browser cache for every lightbox image inside the currently
// open project as soon as its detail accordion is shown. Cached images
// then resolve whenImageReady() synchronously, so the open animation is
// instant. Scoped to [data-project].is-active so hover-preloaded but
// unopened project details are NOT preloaded.
function preloadLightboxImages() {
  document
    .querySelectorAll('[data-project].is-active [data-lightbox]:not([data-lightbox-preloaded])')
    .forEach(trigger => {
      trigger.setAttribute('data-lightbox-preloaded', '')
      const sm = trigger.dataset.lightboxSm
      const md = trigger.dataset.lightboxMd
      const xl = trigger.dataset.lightboxXl
      if (!md) return
      const img = new Image()
      img.fetchPriority = 'low'
      img.srcset = `${sm} 640w, ${md} 1280w, ${xl} 1920w`
      img.sizes = '100vw'
      img.src = md
    })
}

window.addEventListener('init:sliders', preloadLightboxImages)
